import { gql } from '@apollo/client'

export const RESOLVE_INSIGHT = gql`
  mutation ResolveInsight($data: ResolveInsightInput!) {
    resolveInsight(data: $data)
  }
`
